/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { parseBackendErrors } from "../helpers/parseBackendErrors";
import { updateProfile } from "./../helpers/user";
import { useSelector, useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import {
  Button,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { updateProfile as updateProfileAction, CheckAdditionalDetails, Logout } from "./../store/actions/app.js";
import { isValidPhoneNumber } from "react-phone-number-input";
import MuiPhoneInput from "material-ui-phone-number";
import { CleanAssets } from "./../store/actions/assets";

const AdditionalDetails = () => {

  // state
  const [submitting, setSubmitting] = useState(false);

  // redux
  const { additional_details, user, token } = useSelector((state) => state.app);
  const dispatch = useDispatch();

  // hooks
  const { control, handleSubmit, errors } = useForm();
  const { enqueueSnackbar } = useSnackbar();

  // methods
  const handleProfileUpdate = async (form) => {
    setSubmitting(true);
    const [error, response] = await updateProfile(
      user._id,
      token,
      form
    );
    setSubmitting(false);
    if (error) {
      const parsed_errors = parseBackendErrors(error.response);
      enqueueSnackbar(parsed_errors, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "center",
        },
      });
      return;
    }
    enqueueSnackbar("Success! Your profile has been updated.", {
      variant: "success",
      anchorOrigin: {
        vertical: "top",
        horizontal: "center",
      },
    });
    dispatch(updateProfileAction(response.data));
    dispatch(CheckAdditionalDetails(false));
  };

  const handleLogout = () => {
    dispatch(Logout());
    dispatch(CleanAssets());
    dispatch(CheckAdditionalDetails(false));
  };

  return (
    <Dialog
      open={additional_details}
      fullWidth={true}
      onClose={() => {
        dispatch(CheckAdditionalDetails(false));
      }}
    >
      <DialogTitle>One More Thing</DialogTitle>
      <form onSubmit={handleSubmit(handleProfileUpdate)} className="px-4 pb-4">
        <Typography variant="body1" className="mb-3">
          Welcome to Bluesphere Caron! In order to continue, please provide additional information bellow:
        </Typography>
        <Controller
          as={
            <TextField
              label="First Name *"
              autoComplete="new-password"
              fullWidth={true}
              variant="outlined"
              error={errors.first_name && true}
              helperText={errors?.first_name?.message}
              className="mb-3"
              inputProps={{ maxLength: 30 }}
            />
          }
          name="first_name"
          control={control}
          defaultValue={""}
          rules={{
            required: "This field is required.",
          }}
        />
        <Controller
          as={
            <TextField
              label="Last Name *"
              autoComplete="new-password"
              fullWidth={true}
              variant="outlined"
              error={errors.last_name && true}
              helperText={errors?.last_name?.message}
              className="mb-3"
              inputProps={{ maxLength: 30 }}
            />
          }
          name="last_name"
          control={control}
          defaultValue={""}
          rules={{
            required: "This field is required.",
          }}
        />
        <Controller
          as={
            <MuiPhoneInput
              label="Phone Number"
              defaultCountry="us"
              onlyCountries={["us", "ca"]}
              disableAreaCodes={true}
              countryCodeEditable={false}
              variant="outlined"
              fullWidth={true}
              className="mb-3"
              error={errors.phone && true}
              helperText={
                errors?.phone?.message
                  ? errors?.phone?.message
                  : "Please provide a valid phone number"
              }
            />
          }
          name="phone"
          control={control}
          defaultValue={""}
          rules={{
            validate: (value) => {
              if (value && !isValidPhoneNumber(value)) {
                return "Enter a valid phone number";
              }
            },
          }}
        />
        <div className="d-flex justify-content-between">
          <Button
            color="secondary"
            variant="outlined"
            onClick={handleLogout}
          >
            Logout
          </Button>
          <Button
            disabled={submitting}
            variant="contained"
            color="primary"
            type="submit"
          >
            Continue
          </Button>
        </div>
      </form>
    </Dialog>
  );
};
export default AdditionalDetails;
